import { useRef, useState } from "react";
import { Camera, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/lib/i18n";

export const photoUrl = (id) => (id ? `${process.env.REACT_APP_BACKEND_URL}/api/public/files/${id}` : null);

export function DishPhoto({ id, name, className = "h-14 w-14" }) {
  if (!id) return null;
  return <img data-testid={`dish-photo-${name}`} src={photoUrl(id)} alt={name} loading="lazy" className={`${className} shrink-0 rounded-xl object-cover`} />;
}

export function DishPhotoUpload({ rid, item, onChanged }) {
  const { t } = useT();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    try { const { data } = await api.post(`/restaurants/${rid}/items/${item.id}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } }); onChanged(data.file_id); toast.success(t("photo_uploaded")); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); e.target.value = ""; }
  };
  const remove = async () => { try { await api.delete(`/restaurants/${rid}/items/${item.id}/photo`); onChanged(null); } catch (ex) { toast.error(errMsg(ex)); } };
  return (
    <div className="flex items-center gap-3">
      {item.photo_id ? <DishPhoto id={item.photo_id} name={item.name} className="h-20 w-20" /> : <div className="flex h-20 w-20 items-center justify-center rounded-xl bg-slate-100 text-slate-400"><Camera size={22} /></div>}
      <div className="flex flex-col gap-2">
        <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" data-testid="dish-photo-input" onChange={upload} />
        <button type="button" data-testid="dish-photo-upload-btn" disabled={busy} onClick={() => ref.current?.click()} className="rounded-full border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:border-[#5aa469] disabled:opacity-60">{busy ? "…" : item.photo_id ? t("change_photo") : t("upload_photo")}</button>
        {item.photo_id && <button type="button" data-testid="dish-photo-remove-btn" onClick={remove} className="flex items-center gap-1 text-xs font-semibold text-rose-600"><Trash2 size={12} />{t("remove_photo")}</button>}
      </div>
    </div>
  );
}
